import React from "react";
import { Row } from "react-bootstrap";

const CommonTitleBar = ({
  title = "",
  isCreateBtn = false,
  createBtnText = "",
  onCreateBtnClick = () => {},
  isCreateBtn2 = false,
  createBtnText2 = "",
  onCreateBtnClick2 = () => {},
  isLoading = false,
}) => {
  return (
    <Row>
      <div className="g_between">
        <h1 className="main_title">{title}</h1>
        <div className="d-flex gap-3">
          {isCreateBtn && (
            <button className="main_btn" onClick={onCreateBtnClick}>
              {createBtnText}
            </button>
          )}
          {isCreateBtn2 && (
            <button
              className="main_btn"
              onClick={onCreateBtnClick2}
              disabled={isLoading}
            >
              {createBtnText2}
            </button>
          )}
        </div>
      </div>
    </Row>
  );
};

export default CommonTitleBar;
